<template>
  <div
    class="flex flex-col lg:flex-row w-full gap-6 p-2 max-h-screen overflow-y-auto"
  >
    <!-- Video qismi -->
    <div class="w-full lg:flex-[2]">
      <div class="rounded-xl shadow-md">
        <iframe
          class="w-full aspect-video object-cover rounded-xl"
          :src="video.src"
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
          :title="video.title"
        ></iframe>
        <!--        <video-->
        <!--          class="w-full aspect-video object-cover rounded-xl"-->
        <!--          controls-->
        <!--          :poster="video.wrapperUrl"-->
        <!--        >-->
        <!--          <source :src="video.src" type="video/mp4" />-->
        <!--        </video>-->
      </div>

      <h2 class="text-xl font-semibold mt-4">{{ video.title }}</h2>

      <div class="flex items-center justify-between mt-2 flex-wrap gap-2">
        <!--        <div>-->
        <!--          <p class="font-medium">{{ video.channel }}</p>-->
        <!--          <p class="text-sm text-gray-500">{{ video.subtitle }}</p>-->
        <!--        </div>-->
        <!--        <button-->
        <!--          class="bg-red-600 text-white text-sm px-4 py-1 rounded-full hover:bg-red-700"-->
        <!--        >-->
        <!--          Подписаться-->
        <!--        </button>-->
      </div>

      <!--      <p class="text-gray-700 text-sm mt-4">-->
      <!--        {{ video.description }}-->
      <!--      </p>-->
    </div>

    <!-- Ro'yxat paneli -->
    <div class="w-full lg:flex-[1] space-y-4 overflow-y-auto max-h-[400px]">
      <!--      <div-->
      <!--        v-for="(item, index) in videoList"-->
      <!--        :key="index"-->
      <!--        :class="[-->
      <!--          'flex items-start gap-3 cursor-pointer p-2 rounded-lg',-->
      <!--          index === 0 ? 'bg-gray-100' : 'hover:bg-gray-50',-->
      <!--        ]"-->
      <!--      >-->
      <!--        <img-->
      <!--          :src="item.wrapperUrl"-->
      <!--          alt="thumbnail"-->
      <!--          class="w-28 h-20 object-cover rounded-md"-->
      <!--        />-->
      <!--        <div>-->
      <!--          <p class="text-sm font-semibold leading-snug">-->
      <!--            {{ item.title }}-->
      <!--          </p>-->
      <!--          &lt;!&ndash;          <p class="text-xs text-gray-500">{{ item.subtitle }}</p>&ndash;&gt;-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import http from "@/http";
import { useMenuController } from "@/composables/useTriggerMenu";
export default {
  setup() {
    const { hideMenu } = useMenuController();

    return {
      hideMenu,
    };
  },
  data() {
    return {
      video: {
        src: "",
        // src: "/media/test-vidio.a466af00.mp4",
        wrapperUrl: "/img/test.c92764e2.jpg",
        title: "",
        // title: "Приключения в мире чудес: сказочные истории",
        channel: "Narratives glues",
        subtitle: "Zumba sessions",
        description: "",
      },
      videoList: [
        // {
        //   title: "Narratives glues, something lorem text...",
        //   subtitle: "Zumba sessions",
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        // },
        // {
        //   title: "Exploring the wonders of the ocean...",
        //   subtitle: "Dance fitness classes",
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        // },
        // {
        //   title: "The art of storytelling, weaving tales...",
        //   subtitle: "Rhythm movement sessions",
        //   wrapperUrl: "/img/test.c92764e2.jpg",
        // },
      ],
    };
  },
  mounted() {
    this.getVidio();
    this.getVidioList();
  },
  methods: {
    async getVidio() {
      const videoId = this.$route.query.videoId;
      const token = this.$route.query.accessToken
        ? this.$route.query.accessToken
        : localStorage.getItem("accessToken");
      localStorage.setItem("accessToken", token);
      try {
        let response;
        setTimeout(async () => {
          localStorage.setItem("accessToken", token);
          response = await http.get(`/video/vimeo-url?videoId=${videoId}`);
        }, 1000);
        let videoUrl = response.data.data.videoUrl;
        this.video.title = response.data.data.title;
        this.video.description = response.data.data.description;
        this.video.src = `${videoUrl}?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`;
      } catch (error) {
        console.error("failed", error);
      }
    },
    async getVidioList() {
      try {
        let response = await http.post("/video/all-videos", {});
        this.videoList = response.data.data.content;
      } catch (error) {
        console.error("failed", error);
      }
    },
  },
};
</script>
